import React, { Component } from 'react';
import { Image, Row, Col} from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel'
import './carousel.css'
import AOS from 'aos';

import C_Bitcoin from '../../../../img/Cryptomonedas/Bitcoin.svg'
import C_Litecoin from '../../../../img/Cryptomonedas/Litecoin.svg'
import C_Etherum from '../../../../img/Cryptomonedas/Eth.svg'
import C_XRP from '../../../../img/Cryptomonedas/XRP.svg'
import C_Dash from '../../../../img/Cryptomonedas/Dash.svg'

class CarouselMe extends Component{
    constructor(props){
        super(props)
        this.state ={
            width:'',
            coins:this.props.coins,
            prices:'',
        }
    }
    componentDidMount() {
    this.connectPricesSocket();

        AOS.init({
            delay: 0, // values from 0 to 3000, with step 50ms
            duration: 800, // values from 0 to 3000, with step 50ms
            easing: 'ease',
        });
        this.setState({width:window.innerWidth})


        window.onresize = ()=>{
            this.setState({width:window.innerWidth, index:0})

        };
        // console.log(this.props)
    }

    connectPricesSocket() {
        const self = this;

        var prices ;
        let flat=true;

        var wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
        var wsHost = window.location.hostname === "localhost" ? "50.116.20.64:8765" : window.location.host + "/ws/prices";
        var pricesSocket = new WebSocket(wsProtocol + "//" + wsHost);
        pricesSocket.onopen = function (event) {
          pricesSocket.send('GNTWIREBIT')
        }

        pricesSocket.onmessage = function (event) {
            try {
                var object = JSON.parse(event.data);
                prices ={
                    Btc:{ price:object['BTC'], statusBid:'', statusAsk:''},
                    Ltc:{ price:object['LTC'], statusBid:'', statusAsk:''},
                    Eth:{ price:object['ETH'], statusBid:'', statusAsk:''},
                    Xrp:{ price:object['XRP'], statusBid:'', statusAsk:''}
                }
                if(self.state.prices){
                    prices.Btc.statusBid = (prices.Btc.price.bid > self.state.prices.Btc.price.bid)?'#025fc9':'#F18A5F';
                    prices.Btc.statusAsk = (prices.Btc.price.ask > self.state.prices.Btc.price.ask)?'#025fc9':'#F18A5F';
                    prices.Ltc.statusBid = (prices.Ltc.price.bid > self.state.prices.Ltc.price.bid)?'#025fc9':'#F18A5F';
                    prices.Ltc.statusAsk = (prices.Ltc.price.ask > self.state.prices.Ltc.price.ask)?'#025fc9':'#F18A5F';
                    prices.Eth.statusBid = (prices.Eth.price.bid > self.state.prices.Eth.price.bid)?'#025fc9':'#F18A5F';
                    prices.Eth.statusAsk = (prices.Eth.price.ask > self.state.prices.Eth.price.ask)?'#025fc9':'#F18A5F';
                    prices.Xrp.statusBid = (prices.Xrp.price.bid > self.state.prices.Xrp.price.bid)?'#025fc9':'#F18A5F';
                    prices.Xrp.statusAsk = (prices.Xrp.price.ask > self.state.prices.Xrp.price.ask)?'#025fc9':'#F18A5F';
                    // prices.Xrp.statusAsk = (prices.Xrp.price.ask > self.state.prices.Xrp.price.ask)?'green':'red';
                }
                if(prices && flat){
                    self.setState({ prices:prices})
                    flat=false
                }
            } catch (e) {}
        }

        setInterval(() => {
            if(prices)
                self.setState({ prices:prices})
        }, 5000);
      }



      renderPrices(coin){

          switch(coin){
            case 'Bitcoin':
                return(
                    <div className='coinPrice' style={{display:'flex'}}>
                        {/* Bid:<p style={{margin:'0 .5em', color:(this.state.prices.Btc)&&this.state.prices.Btc.statusBid}}> ${(this.state.prices.Btc && coin == 'Bitcoin') && this.state.prices.Btc.price.bid.toFixed(2)} USD </p>
                        Ask:<p style={{margin:'0 .5em', color:(this.state.prices.Btc)&&this.state.prices.Btc.statusAsk}}> ${(this.state.prices.Btc && coin == 'Bitcoin') && this.state.prices.Btc.price.ask.toFixed(2)} USD </p> */}
                        <p  style={{margin:'0 .5em', color:(this.state.prices.Btc)&&this.state.prices.Btc.statusAsk}}> ${(this.state.prices.Btc && coin == 'Bitcoin') && this.state.prices.Btc.price.ask.toFixed(2)} USD </p>
                    </div>
                );
            case 'Litecoin':
                return(
                    <div className='coinPrice' style={{display:'flex'}}>
                        {/* Bid:<p style={{margin:'0 .5em', color:(this.state.prices.Ltc)&&this.state.prices.Ltc.statusBid}}> ${(this.state.prices.Ltc && coin == 'Litecoin') && this.state.prices.Ltc.price.bid.toFixed(2)} USD</p>
                        Ask:<p style={{margin:'0 .5em', color:(this.state.prices.Ltc)&&this.state.prices.Ltc.statusAsk}}> ${(this.state.prices.Ltc && coin == 'Litecoin') && this.state.prices.Ltc.price.ask.toFixed(2)} USD</p> */}
                        <p  style={{margin:'0 .5em', color:(this.state.prices.Ltc)&&this.state.prices.Ltc.statusAsk}}> ${(this.state.prices.Ltc && coin == 'Litecoin') && this.state.prices.Ltc.price.ask.toFixed(2)} USD</p>
                    </div>
                );
            case 'Etherum':
                return(
                    <div className='coinPrice' style={{display:'flex'}}>
                        {/* Bid:<p style={{margin:'0 .5em', color:(this.state.prices.Eth)&&this.state.prices.Eth.statusBid}}> ${(this.state.prices.Eth && coin == 'Etherum') && this.state.prices.Eth.price.bid.toFixed(2)} USD</p>
                        Ask:<p style={{margin:'0 .5em', color:(this.state.prices.Eth)&&this.state.prices.Eth.statusAsk}}> ${(this.state.prices.Eth && coin == 'Etherum') && this.state.prices.Eth.price.ask.toFixed(2)} USD</p> */}
                        <p  style={{margin:'0 .5em', color:(this.state.prices.Eth)&&this.state.prices.Eth.statusAsk}}> ${(this.state.prices.Eth && coin == 'Etherum') && this.state.prices.Eth.price.ask.toFixed(2)} USD</p>
                    </div>
                );
            case 'XRP':
                return(
                    <div className='coinPrice' style={{display:'flex'}}>
                        {/* Bid:<p style={{margin:'0 .5em', color:(this.state.prices.Xrp)&&this.state.prices.Xrp.statusBid}}> ${(this.state.prices.Xrp && coin == 'XRP') && this.state.prices.Xrp.price.bid.toFixed(2)}  USD</p>
                      Ask:<p style={{margin:'0 .5em', color:(this.state.prices.Xrp)&&this.state.prices.Xrp.statusAsk}}> ${(this.state.prices.Xrp && coin == 'XRP') && this.state.prices.Xrp.price.ask.toFixed(2)}  USD</p> */}
                        <p  style={{margin:'0 .5em', color:(this.state.prices.Xrp)&&this.state.prices.Xrp.statusAsk}}> ${(this.state.prices.Xrp && coin == 'XRP') && this.state.prices.Xrp.price.ask.toFixed(2)}  USD</p>
                    </div>
                );
           default:
            return(
                <div style={{display:'flex'}}>
                    --
                    --
                </div>
            );
          }
      }

    renderCarruselItems(){
    // 1 columna < 576
    // 2 columna < 768
    // 3 columna < 1100
        var itemsRender=[]
        var total_Items=0
        if(this.state.width < 576){
            for (let index = 0; index < this.state.coins.length; index++) {
                itemsRender.push(
                    <Carousel.Item>
                    <Row >
                        <Col >
                            <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                                <Image src={this.state.coins[index].img} />

                                <p> {this.state.coins[index].coin}</p>
                                {this.renderPrices(this.state.coins[index].coin)}
                            </div>
                        </Col>
                    </Row>
                    </Carousel.Item>
                )
            }
        }else if(this.state.width < 768){
            total_Items = Math.ceil(this.state.coins.length/2)
            // console.log('Items: '+this.state.coins.length+' Division: '+total_Items)

            for (let index = 0; index < this.state.coins.length; index+=2) {
                itemsRender.push(
                    <Carousel.Item>
                    <Row className='rowItem'>
                        <Col>
                            <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                                <Image src={this.state.coins[index].img} />

                                <p> {this.state.coins[index].coin}</p>
                                {this.renderPrices(this.state.coins[index].coin)}


                            </div>
                        </Col>
                        {
                            (this.state.coins[index+1])&&
                            <Col>
                                <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                                    <Image src={this.state.coins[index+1].img} />

                                    <p> {this.state.coins[index+1].coin}</p>
                                    {this.renderPrices(this.state.coins[index+1].coin)}
                                </div>
                            </Col>
                        }

                    </Row>
                    </Carousel.Item>
                )
            }

        }else if(this.state.width < 1100){
            total_Items = Math.floor(this.state.coins.length/3)
            // console.log('Items: '+this.state.coins.length+' Division: '+total_Items)

            for (let index = 0; index < this.state.coins.length; index+=3) {
                itemsRender.push(
                    <Carousel.Item>
                    <Row className='rowItem'>
                        <Col md={4}>
                            <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                                <Image src={this.state.coins[index].img} />

                                <p> {this.state.coins[index].coin}</p>
                                {this.renderPrices(this.state.coins[index].coin)}
                            </div>
                        </Col>
                        {
                            (this.state.coins[index+1])&&
                            <Col md={4}>
                                <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                                    <Image src={this.state.coins[index+1].img} />

                                    <p> {this.state.coins[index+1].coin}</p>
                                    {this.renderPrices(this.state.coins[index].coin+1)}
                                </div>
                            </Col>
                        }
                        {
                            (this.state.coins[index+2])&&
                            <Col md={4}>
                                <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                                    <Image src={this.state.coins[index+2].img} />

                                    <p> {this.state.coins[index+2].coin}</p>
                                    {this.renderPrices(this.state.coins[index].coin+2)}
                                </div>
                            </Col>
                        }

                    </Row>
                    </Carousel.Item>
                )
            }

        }else {
            total_Items = Math.floor(this.state.coins.length/4)
            // console.log('Items: '+this.state.coins.length+' Division: '+total_Items)

            for (let index = 0; index < this.state.coins.length; index+=4) {
                itemsRender.push(
                    <Carousel.Item>
                    <Row className='rowItem'>
                        <Col  md={3}className='itemME'>
                            <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                                <Image src={this.state.coins[index].img} />

                                <p> {this.state.coins[index].coin}</p>
                                {this.renderPrices(this.state.coins[index].coin)}
                            </div>
                        </Col>
                        {
                            (this.state.coins[index+1])&&
                            <Col  md={3}className='itemME'>
                                <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                                    <Image src={this.state.coins[index+1].img} />

                                    <p> {this.state.coins[index+1].coin}</p>
                                    {this.renderPrices(this.state.coins[index+1].coin)}
                                </div>
                            </Col>
                        }
                        {
                            (this.state.coins[index+2])&&
                            <Col  md={3}className='itemME'>
                                <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                                    <Image src={this.state.coins[index+2].img} />

                                    <p> {this.state.coins[index+2].coin}</p>
                                    {this.renderPrices(this.state.coins[index+2].coin)}
                                </div>
                            </Col>
                        }
                         {
                            (this.state.coins[index+3])&&
                            <Col  md={3}className='itemME'>
                                <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                                    <Image src={this.state.coins[index+3].img} />

                                    <p> {this.state.coins[index+3].coin}</p>
                                    {this.renderPrices(this.state.coins[index+3].coin)}
                                </div>
                            </Col>
                        }

                    </Row>
                    </Carousel.Item>
                )
            }

        }
        return itemsRender
    }


    render(){
        return(
            <div id='carousel'>
                {/* --------------- carrousel de monedas --------------- */}
                {/* <Carousel indicators={false} >
                    {this.renderCarruselItems()}
                {

                }
                </Carousel> */}
                {/* --------------- END carrousel de monedas --------------- */}




                {/* --------------- slide --------------- */}

                <div className='sliderAnimation' >
                    <div  className='hijoslider'>
                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_Bitcoin} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> Bitcoin </div>
                                {this.renderPrices('Bitcoin')}
                            </div>
                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_Litecoin} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> Litecoin </div>
                                {this.renderPrices('Litecoin')}
                            </div>
                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_Etherum} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> Ethereum </div>
                                {this.renderPrices('Etherum')}
                            </div>
                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_XRP} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> XRP </div>
                                {this.renderPrices('XRP')}
                            </div>

                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_Bitcoin} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> Bitcoin </div>
                                {this.renderPrices('Bitcoin')}
                            </div>
                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_Litecoin} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> Litecoin </div>
                                {this.renderPrices('Litecoin')}
                            </div>
                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_Etherum} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> Ethereum </div>
                                {this.renderPrices('Etherum')}
                            </div>
                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_XRP} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> XRP </div>
                                {this.renderPrices('XRP')}
                            </div>

                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_Bitcoin} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> Bitcoin </div>
                                {this.renderPrices('Bitcoin')}
                            </div>
                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_Litecoin} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> Litecoin </div>
                                {this.renderPrices('Litecoin')}
                            </div>
                            <div style={{display:'flex',alignItems:'center', margin:'10px 1em'}}>
                                <div> <Image src={C_Etherum} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> Ethereum </div>
                                {this.renderPrices('Etherum')}
                            </div>
                            <div style={{display:'flex',alignItems:'center', marginLeft:'1em',marginRight:'1em'}}>
                                <div> <Image src={C_XRP} style={{height:'30px'}}/> </div>
                                <div style={{marginRight:'.5em', marginLeft:'.25em', color:'#719EFF'}}> XRP </div>
                                {this.renderPrices('XRP')}
                            </div>



                    </div>
                </div>
                {/* --------------- END slide --------------- */}



                {/* --------------- statics coins --------------- */}

                {/* <Row>
                    <Col >
                        <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                            <Image src={C_Bitcoin} />
                            <p>Bitcoin</p>
                            {this.renderPrices('Bitcoin')}
                        </div>
                    </Col>
                    <Col >
                        <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                            <Image src={C_Litecoin} />
                            <p>Litecoin</p>
                            {this.renderPrices('Litecoin')}
                        </div>
                    </Col>
                    <Col >
                        <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                            <Image src={C_Etherum} />
                            <p>Etherum</p>
                            {this.renderPrices('Etherum')}
                        </div>
                    </Col>
                    <Col >
                        <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                            <Image src={C_XRP} />
                            <p>XRP</p>
                            {this.renderPrices('XRP')}
                        </div>
                    </Col>
                    <Col >
                        <div className='coin' data-aos="fade-up"  data-aos-delay="0">
                            <Image src={C_Dash} />
                            <p>Dash</p>
                            {this.renderPrices('Dash')}

                        </div>
                    </Col>
                </Row> */}
                {/* --------------- END statics coins --------------- */}

            </div>
        );
    }
} export default CarouselMe;
